import React, { useState } from 'react';
import AnimatedButton from './AnimatedButton';

const ContactForm: React.FC = () => {
  const [formData, setFormData] = useState({ name: '', phone: '', email: '' });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Mensagem formatada para o WhatsApp
    const message = encodeURIComponent(`Olá, meu nome é ${formData.name}.\nMeu e-mail é: ${formData.email}\nMeu WhatsApp é: ${formData.phone}\n\nGostaria de receber uma proposta para reduzir minha conta de energia.`);
    window.open(`https://wa.me/5573998595834?text=${message}`, '_blank');
  };

  return (
    <section id="contato" className="py-24 bg-white relative overflow-hidden">
      {/* Elementos decorativos de fundo */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#39B54A]/5 rounded-full blur-[120px] -z-10"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#39B54A]/5 rounded-full blur-[120px] -z-10"></div>

      <div className="container mx-auto px-6">
        {/* Card Principal com Borda Animada */}
        <div className="relative max-w-6xl mx-auto p-[2.5px] rounded-[3rem] group shadow-2xl overflow-hidden">
          
          {/* Container da Borda Rotativa */}
          <div className="border-animation-container">
            <div className="rotating-border-beam"></div>
          </div>

          {/* Conteúdo do Card (Glass Morphism) */}
          <div className="relative z-10 glass-morphism-solar-light rounded-[3rem] overflow-hidden flex flex-col lg:flex-row min-h-[600px]">
            
            {/* Lado Esquerdo: Identidade Verde */}
            <div className="lg:w-[42%] bg-[#39B54A] p-12 lg:p-20 flex flex-col justify-center relative">
              {/* Overlay de Textura Sutil */}
              <div className="absolute inset-0 opacity-10 pointer-events-none">
                <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
                  <defs>
                    <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
                      <path d="M 40 0 L 0 0 0 40" fill="none" stroke="white" strokeWidth="1" />
                    </pattern>
                  </defs>
                  <rect width="100%" height="100%" fill="url(#grid)" />
                </svg>
              </div>

              <div className="relative z-10 space-y-8">
                <h3 className="text-4xl lg:text-6xl font-black text-white leading-tight">
                  Pronto para dar o próximo passo?
                </h3>
                <p className="text-white/90 text-lg font-medium leading-relaxed max-w-md">
                  Não perca mais dinheiro com tarifas abusivas. Nossa equipe técnica desenhará o projeto ideal para seu consumo.
                </p>
                
                <div className="pt-8 space-y-8">
                  <div className="flex items-center space-x-6">
                    <div className="w-14 h-14 bg-white/20 border border-white/30 rounded-2xl flex items-center justify-center backdrop-blur-xl shadow-lg">
                      <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                      </svg>
                    </div>
                    <div>
                      <p className="text-white/70 text-[10px] uppercase tracking-[0.2em] font-black mb-1">Fale conosco agora</p>
                      <p className="text-white font-black text-xl tracking-tight">(73) 99859-5834</p>
                    </div>
                  </div>

                  <div className="flex items-center space-x-6">
                    <div className="w-14 h-14 bg-white/20 border border-white/30 rounded-2xl flex items-center justify-center backdrop-blur-xl shadow-lg">
                      <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                      </svg>
                    </div>
                    <div>
                      <p className="text-white/70 text-[10px] uppercase tracking-[0.2em] font-black mb-1">E-mail de suporte</p>
                      <p className="text-white font-black text-lg lg:text-xl tracking-tight">contato@energysolaris.com</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Lado Direito: Formulário Cinza Claro */}
            <div className="lg:w-[58%] p-12 lg:p-20 bg-[#F3F4F6]/80 flex flex-col justify-center">
              <form onSubmit={handleSubmit} className="space-y-6">
                <div className="space-y-2">
                  <label className="block text-[10px] font-black text-[#39B54A] uppercase tracking-[0.2em] ml-2">Seu nome completo</label>
                  <input 
                    type="text" 
                    required
                    placeholder="Ex: João Silva"
                    className="w-full bg-white border border-gray-200 rounded-2xl px-8 py-5 text-gray-800 placeholder-gray-300 focus:outline-none focus:border-[#39B54A] focus:ring-1 focus:ring-[#39B54A]/20 transition-all font-bold shadow-sm"
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  />
                </div>

                <div className="grid md:grid-cols-2 gap-6">
                  <div className="space-y-2">
                    <label className="block text-[10px] font-black text-[#39B54A] uppercase tracking-[0.2em] ml-2">WhatsApp</label>
                    <input 
                      type="tel" 
                      required
                      placeholder="Ex: (73) 99859-5834"
                      className="w-full bg-white border border-gray-200 rounded-2xl px-8 py-5 text-gray-800 placeholder-gray-300 focus:outline-none focus:border-[#39B54A] transition-all font-bold shadow-sm"
                      value={formData.phone}
                      onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                    />
                  </div>
                  <div className="space-y-2">
                    <label className="block text-[10px] font-black text-[#39B54A] uppercase tracking-[0.2em] ml-2">E-mail corporativo</label>
                    <input 
                      type="email" 
                      required
                      placeholder="seu@email.com"
                      className="w-full bg-white border border-gray-200 rounded-2xl px-8 py-5 text-gray-800 placeholder-gray-300 focus:outline-none focus:border-[#39B54A] transition-all font-bold shadow-sm"
                      value={formData.email}
                      onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    />
                  </div>
                </div>
                
                <div className="pt-8">
                  <AnimatedButton 
                    text="Falar com especialista agora" 
                    type="submit"
                    className="w-full !rounded-2xl !py-7 shadow-xl"
                  />
                </div>

                <p className="text-center text-gray-400 text-[10px] font-bold tracking-tight mt-6">
                  Ao enviar este formulário, você será redirecionado para o nosso WhatsApp oficial.
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;